import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { SortEvent } from '@pwc-bei/ui';
import { NotificationModel } from '../../models/notification.model';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

@Component({
    selector: 'app-notification-list',
    templateUrl: './notification-list.component.html',
    styleUrls: ['./notification-list.component.scss'],
    standalone: false
})
export class NotificationListComponent implements OnInit, AfterViewInit {
  @Input() dataSet: NotificationModel[];
  @Output() read: EventEmitter<NotificationModel> =
    new EventEmitter<NotificationModel>();

  initialized = false;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    registerLocaleData(localeIt, 'it');
  }

  ngAfterViewInit(): void {
    this.initialized = true;
    this.changeDetector.detectChanges();
  }

  readNotification(notification: NotificationModel) {
    if (!notification.isRead) {
      this.read.emit(notification);
    }
  }

  truncateText(text: string, isRead: boolean) {
    if (!isRead && text.length > 50) {
      return text.substring(0, 50) + '...';
    } else {
      return text;
    }
  }
}
